import { AxiosResponse } from "axios";
import axios from "utils/axios";
import { API_BASE_URL, API_COMPANY } from "utils/constants";

export interface Address {
  type: number;
  street: string;
  complement: string;
  number: number;
  city: string;
  state: string;
  countryCode: number;
  zipCode: string;
  district: string;
}

export interface Phone {
  type: number;
  telephone: string;
}

export interface Company {
  name: string;
  site: string;
  taxDocumentNumber: string;
  email: string;
  addresses: Address[];
  phones: Phone[];
  externalLoginURL?: string;
  photo?: string;
}

export interface CompanyIntegrationsResponse {
  stripeApiKey: string | null;
  stripeWebhookSecret: string | null;
  stripeEnabled: boolean;
  stripeWebhookUrl: string;
}

export interface CompanyIntegrationsRequest {
  stripeApiKey: string | null;
  stripeWebhookSecret: string | null;
}

export interface RegisterStripeWebhookRequest {
  stripeApiKey: string | null;
}

const getByExternalLoginURL = (externalLoginURL: string) =>
  axios.get(
    `${API_BASE_URL}${API_COMPANY.BASE_URL}${API_COMPANY.EXTERNAL_LOGIN_URL}/${externalLoginURL}`
  );
const get = () => axios.get(`${API_BASE_URL}${API_COMPANY.BASE_URL}`);
const save = (company: Company) =>
  axios.post(`${API_BASE_URL}${API_COMPANY.BASE_URL}`, company);
const getLogo = async (companyId?: string): Promise<Blob> => {
  const response = await axios.get<Blob>(
    `${API_BASE_URL}${API_COMPANY.BASE_URL}${API_COMPANY.LOGO_URL}${
      companyId ? "/" + companyId : ""
    }`,
    { responseType: "blob" }
  );
  return response.data;
};
const getIntegrations = (): Promise<
  AxiosResponse<CompanyIntegrationsResponse>
> =>
  axios.get<CompanyIntegrationsResponse>(
    `${API_BASE_URL}${API_COMPANY.BASE_URL}${API_COMPANY.INTEGRATIONS_URL}`
  );
const saveIntegrations = (
  data: CompanyIntegrationsRequest
): Promise<AxiosResponse<CompanyIntegrationsResponse>> =>
  axios.put<CompanyIntegrationsResponse>(
    `${API_BASE_URL}${API_COMPANY.BASE_URL}${API_COMPANY.INTEGRATIONS_URL}`,
    data
  );

const registerStripeWebhook = (
  data: RegisterStripeWebhookRequest
): Promise<AxiosResponse<CompanyIntegrationsResponse>> =>
  axios.post<CompanyIntegrationsResponse>(
    `${API_BASE_URL}${API_COMPANY.BASE_URL}${API_COMPANY.STRIPE_WEBHOOK_REGISTER_URL}`,
    data
  );

const companyAPI = {
  get,
  save,
  getByExternalLoginURL,
  getLogo,
  getIntegrations,
  saveIntegrations,
  registerStripeWebhook,
};

export default companyAPI;
